import { FormEvent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, type AdminUser } from '../api';

export default function Admin() {
  const [users, setUsers] = useState<AdminUser[]>([]);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const reload = () => api.listUsers().then(setUsers).catch((e) => setErr(e.message));
  useEffect(() => { reload(); }, []);

  async function create(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    try {
      await api.createUser(username, password, isAdmin);
      setUsername(''); setPassword(''); setIsAdmin(false);
      reload();
    } catch (e: any) { setErr(e.message); }
  }

  async function resetPw(u: AdminUser) {
    const pw = prompt(`Nouveau mot de passe pour ${u.username} ?`);
    if (!pw) return;
    try { await api.resetPassword(u.id, pw); alert('Mot de passe réinitialisé'); }
    catch (e: any) { alert('Erreur: ' + e.message); }
  }

  async function del(u: AdminUser) {
    if (!confirm(`Supprimer ${u.username} ?`)) return;
    try { await api.deleteUser(u.id); reload(); }
    catch (e: any) { alert('Erreur: ' + e.message); }
  }

  return (
    <div className="admin-page">
      <p><Link to="/">← Retour</Link></p>
      <h1>Gestion des utilisateurs</h1>
      {err && <div style={{ color: '#c00' }}>{err}</div>}
      <table>
        <thead><tr><th>ID</th><th>Username</th><th>Admin</th><th>Créé</th><th></th></tr></thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id}>
              <td>{u.id}</td>
              <td>{u.username}</td>
              <td>{u.is_admin ? '✓' : ''}</td>
              <td>{u.created_at}</td>
              <td>
                <button onClick={() => resetPw(u)}>reset pw</button>{' '}
                <button onClick={() => del(u)}>supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <form onSubmit={create}>
        <input placeholder="username" value={username} onChange={(e) => setUsername(e.target.value)} required />
        <input type="password" placeholder="password (min 8)" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} />
        <label><input type="checkbox" checked={isAdmin} onChange={(e) => setIsAdmin(e.target.checked)} /> admin</label>
        <button>Créer</button>
      </form>
    </div>
  );
}
